"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreffixSuffixContainer = exports.LinkContainer = exports.IconsSeparatorText = exports.IconContainer = exports.HeadingContainer = exports.CardHeadingAndIconSlot = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CardHeadingAndIconSlot = _styledComponents["default"].div.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__CardHeadingAndIconSlot",
  componentId: "sc-1kwnhkj-0"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;flex:1;display:flex;", " &:first-child{", "}&:last-child{", "}", ""], (0, _coreMixins.advancedSpacing)('padding', [2, 4]), (0, _coreMixins.spacing)('padding-top', 3), (0, _coreMixins.spacing)('padding-bottom', 3), props.justifyIcon === 'right' && (0, _styledComponents.css)(["flex-direction:row-reverse;"]));
});

exports.CardHeadingAndIconSlot = CardHeadingAndIconSlot;

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__IconContainer",
  componentId: "sc-1kwnhkj-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;"]);
});

exports.IconContainer = IconContainer;

var HeadingContainer = _styledComponents["default"].div.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__HeadingContainer",
  componentId: "sc-1kwnhkj-2"
})(function (props) {
  return (0, _styledComponents.css)(["flex-grow:1;", ""], props.hasIcon && (0, _styledComponents.css)(["", ";"], (0, _coreMixins.spacing)("margin-".concat(props.justifyIcon), 4)));
});

exports.HeadingContainer = HeadingContainer;

var PreffixSuffixContainer = _styledComponents["default"].div.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__PreffixSuffixContainer",
  componentId: "sc-1kwnhkj-3"
})(function (props) {
  return (0, _styledComponents.css)(["", ";color:", ";"], _coreMixins.typography.paragraph(props.level === 2 ? 1 : 2, false), props.theme.color.monochrome5["default"]);
});

exports.PreffixSuffixContainer = PreffixSuffixContainer;

var LinkContainer = _styledComponents["default"].div.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__LinkContainer",
  componentId: "sc-1kwnhkj-4"
})(function (props) {
  return (0, _styledComponents.css)(["", " color:", ";"], _coreMixins.typography.paragraph(1, false), props.theme.color.monochrome6["default"]);
});

exports.LinkContainer = LinkContainer;

var IconsSeparatorText = _styledComponents["default"].span.withConfig({
  displayName: "CardHeadingAndIconSlotstyle__IconsSeparatorText",
  componentId: "sc-1kwnhkj-5"
})(function (props) {
  return (0, _styledComponents.css)(["color:", ";", ";font-weight:", ";", ";"], props.theme.color.monochrome5["default"], _coreMixins.typography.paragraph(2, false), props.theme.fontWeight[3], (0, _coreMixins.advancedSpacing)('margin', [1, 0]));
});

exports.IconsSeparatorText = IconsSeparatorText;
//# sourceMappingURL=CardHeadingAndIconSlot.style.js.map